import { render, staticRenderFns } from "./Temas.vue?vue&type=template&id=45f06efe&"
import script from "./Temas.vue?vue&type=script&lang=js&"
export * from "./Temas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports